export default {
  'purchaseReturn.form.company': 'Empresa',
  'purchaseReturn.form.supplier': 'Fornecedor',
  'purchaseReturn.form.releaseDateOf.start': 'Data de Lançamento (De)',
  'purchaseReturn.form.releaseDateOf.end': 'Data de Lançamento (Até)',

  'purchaseReturn.form.table.workOrder': 'Orçamento',
  'purchaseReturn.form.table.purchaseCode': 'Código Compra',
  'purchaseReturn.form.table.purchaseDate': 'Data Compra',
  'purchaseReturn.form.table.manufacturingCode': 'Cód. Fabricante',
  'purchaseReturn.form.table.description': 'Descrição',
  'purchaseReturn.form.table.qtyPurchased': 'Qtde. Comprada',
  'purchaseReturn.form.table.qtyReturned': 'Qtde. Devolvida',
  'purchaseReturn.form.table.qtyToReturn': 'Qtde. a Devolver',

  'purchaseReturn.form.button.generateInvoice': 'Gerar Nota Fiscal',
  'purchaseReturn.form.button.updateData': 'Atualizar Dados',
};
